<template>
    <!-- Group Coaching -->
    <section class="section group-coaching">
        <div class="container">
            <div class="section-heading aos" data-aos="fade-up">
                <h2><span>Tính năng của hệ thống</span></h2>
                <p class="sub-title">Những tính năng ưu việt của hệ thống quản lý giải đấu cầu lông EZBadminton</p>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 d-flex" v-for="item in Group" :key="item.id">
                    <div class="work-grid coaching-grid w-100 aos" data-aos="fade-up">
                        <div class="work-icon">
                            <div class="work-icon-inner">
                                <img :src="require(`@/assets/img/icons/${item.Image}`)" alt="Icon">
                            </div>
                        </div>
                        <div class="work-content">
                            <h3>{{item.Title}}</h3>
                            <p>{{item.Content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Group Coaching -->

</template>

<script>
import Group from '@/assets/json/home-group.json'
export default {
    data() {
        return {
            Group: Group,
        }
    },
}
</script>